import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Layout } from './components/Layout';

const DashboardPage = lazy(() => import('./pages/Dashboard'));
const CommandCenterPage = lazy(() => import('./pages/CommandCenter'));
const SystemDetailPage = lazy(() => import('./pages/SystemDetail'));
const JobsPage = lazy(() => import('./pages/Jobs'));
const AlertsPage = lazy(() => import('./pages/Alerts'));
const BackupsPage = lazy(() => import('./pages/Backups'));
const JudgeAssignmentsPage = lazy(() => import('./pages/JudgeAssignments'));
const CrossReferencesPage = lazy(() => import('./pages/CrossReferences'));
const SmsEvidencePage = lazy(() => import('./pages/SmsEvidence'));
const SendLedgerPage = lazy(() => import('./pages/SendLedger'));
const SecurityPage = lazy(() => import('./pages/Security'));
const ActivityPage = lazy(() => import('./pages/Activity'));
const ModulesPage = lazy(() => import('./pages/Modules'));
const NodesPage = lazy(() => import('./pages/Nodes'));
const CostPage = lazy(() => import('./pages/Cost'));
const LoginPage = lazy(() => import('./pages/Login'));
const AccountPage = lazy(() => import('./pages/Account'));
const LogsPage = lazy(() => import('./pages/Logs'));
const QualityPage = lazy(() => import('./pages/Quality'));
const PipelinePage = lazy(() => import('./pages/Pipeline'));
const AtlasCitadelSyncPage = lazy(() => import('./pages/AtlasCitadelSync'));
const DownstreamGapsPage = lazy(() => import('./pages/DownstreamGaps'));

function RequireAuth() {
  const token = localStorage.getItem('jam_token');
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}

function Loading() {
  return (
    <div className="flex items-center justify-center h-64 text-text-muted text-sm">Loading...</div>
  );
}

export function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route element={<Layout />}>
            <Route index element={<DashboardPage />} />
            <Route path="command" element={<CommandCenterPage />} />
            <Route path="command/:key" element={<SystemDetailPage />} />
            <Route path="jobs" element={<JobsPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route path="backups" element={<BackupsPage />} />
            <Route path="judge-assignments" element={<JudgeAssignmentsPage />} />
            <Route path="cross-references" element={<CrossReferencesPage />} />
            <Route path="atlas-citadel-sync" element={<AtlasCitadelSyncPage />} />
            <Route path="missing-from-atlas" element={<DownstreamGapsPage />} />
            <Route path="sms-evidence" element={<SmsEvidencePage />} />
            <Route path="send-ledger" element={<SendLedgerPage />} />
            <Route path="security" element={<SecurityPage />} />
            <Route path="activity" element={<ActivityPage />} />
            <Route path="modules" element={<ModulesPage />} />
            <Route path="nodes" element={<NodesPage />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="quality" element={<QualityPage />} />
            <Route path="pipeline" element={<PipelinePage />} />
            <Route path="cost" element={<CostPage />} />
            <Route path="account" element={<AccountPage />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
